module.exports = "https://cdn-shared.mathletics.com/teacher-modules/student-reports/23/assets/images/b54d847c50e142879fd449fc9dcf5f81.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/icons/ico_info.svg
// module id = N4Yu
// module chunks = 0